import { otmsHttp, smartHttp } from '@/utils/http/index.js'; // bfsSsoHttp

/**
 * 获取排线列表
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/17461
 */
export function getPlanPage(data, params) {
    return smartHttp.request({
        url: '/plan/page',
        method: 'post',
        data,
        params
    });
}

export function starbucksExport(data) {
    return smartHttp.request({
        url: '/starbucks/inbound/export',
        method: 'post',
        responseType: 'blob',
        data
    });
}

export function getInboundPlanPage(data, params) {
    return smartHttp.request({
        url: '/starbucks/inbound/schedule/page',
        method: 'post',
        data,
        params
    });
}

export function getDetailPage(data, params) {
    return smartHttp.request({
        url: '/starbucks/inbound/schedule/detailPage',
        method: 'post',
        data,
        params
    });
}
export function createShippingDraft(data, params) {
    return smartHttp.request({
        url: '/starbucks/inbound/createShippingDraft',
        method: 'post',
        data,
        params
    });
}

/**
 * 获取排线详情列表
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/17461
 */
export function getPlanInfoPage(data, params) {
    return smartHttp.request({
        url: '/plan/info/page',
        method: 'post',
        data,
        params
    });
}

/**
 * 计划单导入
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/20751
 */
export function planImport(data, params) {
    return smartHttp.request({
        url: '/plan_msg/import',
        method: 'post',
        data,
        params
    });
}

/**
 * 计划单明细删除
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/17473
 */
export function planInfoDelete(data, params) {
    return smartHttp.request({
        url: '/plan/info/delete',
        method: 'post',
        data,
        params
    });
}

/**
 * 计划单(线路)删除
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/17467
 */
export function planLineDelete(data, params) {
    return smartHttp.request({
        url: '/plan/delete',
        method: 'post',
        data,
        params
    });
}

/**
 * 计划单(线路)编辑
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/17465
 */
export function planUpdate(data, params) {
    return smartHttp.request({
        url: '/plan/update',
        method: 'post',
        data,
        params
    });
}

/**
 * 计划单下载
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/20755
 */
export function planMsgExport(data, params) {
    return smartHttp.request({
        url: '/plan_msg/export',
        method: 'post',
        data,
        params
    });
}

/**
 * 发送邮件
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/20757
 */
export function sendEmail(data) {
    return smartHttp.post('/plan_msg/send/email', data);
}

/**
 * 待处理列表查询
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/18477
 */
export function getPendingList(data) {
    return smartHttp.post('/plan/pending/list', data);
}

/**
 * 计划单同意排线
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/18475
 */
export function planConfirm(data) {
    return smartHttp.post('/plan/confirm', data);
}

/**
 * 操作日志
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/7614
 */
export function getOperationLogs(planCode) {
    return smartHttp.get(`/plan/log/${planCode}`);
}

/**
 * 操作日志
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/7614
 */
export function getOperationLogsOld(data) {
    return otmsHttp.post('/oms_plus/order/operation/logs', data);
}

/**
 * 更新(审核)排线
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24657
 */
export function updateTemp(data) {
    return smartHttp.post('/plan_msg/update/temp', data);
}

/**
 * 发送审批邮件
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/24663
 */
export function sendApprovalEmail(data) {
    return smartHttp.post('/plan_msg/send/approval/email', data);
}

/**
 * 查询账号按钮权限列表
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9234
 */
export function getUserButtonList(data, params) {
    return otmsHttp.post({
        url: '/permission-plus/account/permission/list',
        method: 'post',
        data,
        params
    });
}

export function sendLoadfactorEmail(data) {
    return smartHttp.post({
        url: '/plan_msg/send/load_factor/email',
        method: 'post',
        data
    });
}
export function sendExpenseVarianceEmail(data) {
    return smartHttp.post({
        url: '/plan_msg/send/expense_variance/email',
        method: 'post',
        data
    });
}

/**
 * 发送验证码
 */

export function getSmsCode(data) {
    return smartHttp.post({
        url: '/plan/sms_code',
        method: 'post',
        data
    });
}

export function statusToBeConfirmed(data) {
    return smartHttp.post({
        url: '/plan/status/toBeConfirmed',
        method: 'post',
        data
    });
}

export function approveUpdate(data) {
    return smartHttp.post({
        url: '/plan/approve/update',
        method: 'post',
        data
    });
}

export function approveIsApprove(data) {
    return smartHttp.post({
        url: '/plan/approve/isApprove',
        method: 'post',
        data
    });
}

export function createOrder(data) {
    return smartHttp.post({
        url: '/plan/createOrder',
        method: 'post',
        data
    });
}
export function addOthersFee(data) {
    return smartHttp.post({
        url: '/plan/addOthersFee',
        method: 'post',
        data
    });
}
